import { render } from "./SievingDetail.vue?vue&type=template&id=3d5606f7&scoped=true"
import script from "./SievingDetail.vue?vue&type=script&lang=js"
export * from "./SievingDetail.vue?vue&type=script&lang=js"

import "./SievingDetail.vue?vue&type=style&index=0&id=3d5606f7&lang=less&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5606f7"]])

export default __exports__